export const es = {
  nav: {
    services: "Servicios",
    pricing: "Precios",
    areas: "Áreas",
    how: "Cómo Funciona",
    faq: "Preguntas",
    book: "Reservar",
    contact: "Contacto",
    callNow: "Llamar Ahora",
  },
  hero: {
    eyebrow: "Limpieza profesional en NJ y NY",
    titleA: "Espacios limpios,",
    titleB: "vidas mejores.",
    sub: "Servicio bilingüe, asegurado y con productos eco-amigables en New Jersey y New York. Reserva en minutos y recibe a un equipo Rosas en tu puerta.",
    primary: "Reservar Limpieza",
    secondary: "Ver Precios",
    trustA: "Bonded & Insured",
    trustB: "Equipos bilingües",
    trustC: "Productos eco-friendly",
    trustD: "100% Satisfacción",
  },
  stats: {
    homes: "Hogares limpiados",
    areas: "Estados atendidos",
    rating: "Calificación promedio",
    years: "Años de experiencia",
  },
  services: {
    eyebrow: "Servicios",
    title: "Limpieza diseñada para cada espacio",
    sub: "Tarifas competitivas para el mercado de NJ y NY. Sin sorpresas, sin letra chica.",
    cta: "Cotizar",
    items: [
      {
        key: "regular",
        title: "Casas",
        desc: "Limpieza regular semanal, quincenal o mensual para mantener tu hogar impecable.",
        price: "Desde $120",
        features: ["Cocina y baños", "Polvo y pisos", "Productos incluidos"],
      },
      {
        key: "deep",
        title: "Limpieza Profunda",
        desc: "Detalle a fondo de cada rincón. Ideal cada 3-6 meses o antes de eventos.",
        price: "Desde $220",
        features: ["Interior de hornos", "Detalle de baños", "Zócalos y ventanas"],
      },
      {
        key: "apartment",
        title: "Apartamentos",
        desc: "Servicio rápido y económico para apartamentos en NJ y NY.",
        price: "Desde $110",
        features: ["Estudios y 1-BR", "Acabado tipo hotel", "Disponibilidad rápida"],
      },
      {
        key: "office",
        title: "Oficinas",
        desc: "Espacios comerciales que reflejan profesionalismo. Servicio fuera de horario.",
        price: "Desde $150",
        features: ["Áreas comunes", "Sanitización", "Horarios flexibles"],
      },
      {
        key: "move_in_out",
        title: "Move-in / Move-out",
        desc: "Entrega o recepción inmaculada. Perfecto para mudanzas y recuperación de depósito.",
        price: "Desde $280",
        features: ["Vacío completo", "Interior de gabinetes", "Reporte fotográfico"],
      },
      {
        key: "post_construction",
        title: "Post-Construcción",
        desc: "Quitamos polvo de obra, residuos y dejamos tu obra lista para estrenar.",
        price: "Desde $350",
        features: ["Polvo fino", "Residuos y stickers", "Pulido de superficies"],
      },
    ],
  },
  pricing: {
    eyebrow: "Precios transparentes",
    title: "Planes pensados para NJ y NY",
    sub: "Tarifas competitivas. Descuentos automáticos en visitas recurrentes.",
    monthly: "por visita",
    cta: "Elegir plan",
    plans: [
      {
        name: "Básica",
        price: "$120",
        for: "Mantenimiento semanal",
        features: [
          "Hasta 2 habitaciones",
          "Cocina + 1 baño",
          "Polvo, aspirado y trapeado",
          "Productos incluidos",
        ],
        highlight: false,
      },
      {
        name: "Profunda",
        price: "$220",
        for: "Cada 1-3 meses",
        features: [
          "Hasta 3 habitaciones",
          "Detalle interior de baños",
          "Cocina + electrodomésticos",
          "Zócalos, marcos y ventanas",
          "Productos eco incluidos",
        ],
        highlight: true,
      },
      {
        name: "Premium",
        price: "$350",
        for: "Move-in / Move-out / Post-obra",
        features: [
          "Hasta 4 habitaciones",
          "Interior de gabinetes y hornos",
          "Lavado de ventanas interior",
          "Reporte fotográfico",
          "Garantía de 48 horas",
        ],
        highlight: false,
      },
    ],
    note: "Los precios pueden variar según tamaño (sqft), nivel de suciedad y ciudad. Te confirmamos antes de empezar.",
  },
  how: {
    eyebrow: "Cómo funciona",
    title: "Reservar es así de simple",
    steps: [
      {
        n: "01",
        t: "Solicita tu cotización",
        d: "Llena el formulario o llámanos. Te respondemos en menos de 2 horas.",
      },
      {
        n: "02",
        t: "Confirmamos detalles",
        d: "Validamos día, hora, dirección y servicio. Recibes un precio fijo.",
      },
      {
        n: "03",
        t: "Llega tu equipo Rosas",
        d: "Llegamos puntuales, uniformados y con todo lo necesario.",
      },
      {
        n: "04",
        t: "Disfruta tu espacio",
        d: "Te entregamos un hogar impecable con garantía de satisfacción.",
      },
    ],
  },
  why: {
    eyebrow: "Por qué Rosas",
    title: "El estándar de limpieza que tu hogar merece",
    items: [
      {
        t: "Asegurados y Bonded",
        d: "Tranquilidad total: estamos cubiertos y registrados en NJ y NY.",
      },
      {
        t: "Equipo Bilingüe",
        d: "Atención clara en español e inglés, sin malentendidos.",
      },
      {
        t: "Productos Eco-friendly",
        d: "Cuidamos tu familia, tus mascotas y el planeta.",
      },
      {
        t: "Garantía 48h",
        d: "Si algo no quedó perfecto, regresamos sin costo.",
      },
      {
        t: "Personal verificado",
        d: "Background check y entrenamiento continuo.",
      },
      {
        t: "Reserva flexible",
        d: "Reagenda gratis con 24h de aviso. Sin contratos.",
      },
    ],
  },
  areas: {
    eyebrow: "Cobertura",
    title: "Servimos New Jersey y New York",
    sub: "Cubrimos toda el área metropolitana de NJ y NY. ¿No estás seguro si llegamos a tu zona? Llámanos.",
  },
  testimonials: {
    eyebrow: "Lo que dicen",
    title: "Familias de NJ y NY confían en Rosas",
    items: [
      {
        n: "María G.",
        c: "Jersey City, NJ",
        q: "Mi apartamento quedó como nuevo. Llegan a tiempo y el equipo es súper amable. ¡Ya las contraté quincenal!",
      },
      {
        n: "James R.",
        c: "Manhattan, NY",
        q: "Hicieron deep cleaning antes de mi fiesta y todos preguntaron quién limpia. Recomendadísimas.",
      },
      {
        n: "Ana P.",
        c: "Hoboken, NJ",
        q: "Move-out impecable, recuperé el 100% del depósito. Servicio bilingüe, súper profesional.",
      },
      {
        n: "Daniel V.",
        c: "Brooklyn, NY",
        q: "Precio justo y resultado increíble. Productos no tóxicos, perfecto con mi bebé en casa.",
      },
    ],
  },
  booking: {
    eyebrow: "Reserva ahora",
    title: "Cuéntanos sobre tu espacio",
    sub: "Te enviamos una cotización en menos de 2 horas hábiles.",
    name: "Nombre completo",
    phone: "Teléfono",
    email: "Email (opcional)",
    service: "Tipo de servicio",
    date: "Fecha preferida",
    address: "Dirección",
    city: "Ciudad",
    bedrooms: "Habitaciones",
    bathrooms: "Baños",
    sqft: "Tamaño (sqft, opcional)",
    frequency: "Frecuencia",
    freqOptions: {
      one_time: "Una sola vez",
      weekly: "Semanal (-15%)",
      biweekly: "Quincenal (-10%)",
      monthly: "Mensual (-5%)",
    },
    notes: "Notas adicionales",
    submit: "Enviar solicitud",
    submitting: "Enviando...",
    success: "¡Solicitud enviada! Te contactaremos pronto.",
    error: "No se pudo enviar. Llámanos directo al 347-785-5458.",
    estimated: "Estimado",
  },
  faq: {
    eyebrow: "Preguntas frecuentes",
    title: "Resolvemos tus dudas",
    items: [
      {
        q: "¿Cuánto cuesta limpiar mi casa en NJ o NY?",
        a: "Una limpieza regular comienza en $120 y una limpieza profunda en $220. El precio final depende del tamaño, número de habitaciones y nivel de suciedad. Te confirmamos el precio antes de empezar.",
      },
      {
        q: "¿Traen sus propios productos?",
        a: "Sí. Incluimos productos eco-friendly y todo el equipo necesario. Si prefieres productos específicos, también podemos usar los tuyos.",
      },
      {
        q: "¿Necesito estar en casa?",
        a: "No es necesario. Muchos clientes nos dejan instrucciones de entrada (lockbox, doorman, código). Estamos asegurados y bonded para tu tranquilidad.",
      },
      {
        q: "¿Qué pasa si no quedo satisfecho?",
        a: "Tienes 48 horas para avisarnos y regresamos sin costo a corregir cualquier área. Es nuestra garantía Rosas.",
      },
      {
        q: "¿Atienden fines de semana?",
        a: "Sí, atendemos sábados y algunos domingos con cita previa. Reserva con al menos 48 horas de anticipación.",
      },
      {
        q: "¿Hablan español?",
        a: "Sí. Equipo 100% bilingüe español/inglés.",
      },
    ],
  },
  footer: {
    tagline: "Limpieza profesional con corazón. Servimos toda el área metropolitana de New Jersey y New York.",
    nav: "Navegar",
    services: "Servicios",
    contact: "Contacto",
    hours: "Lun–Sáb: 8AM – 7PM",
    rights: "Todos los derechos reservados.",
  },
};

export const en = {
  nav: {
    services: "Services",
    pricing: "Pricing",
    areas: "Areas",
    how: "How it Works",
    faq: "FAQ",
    book: "Book Now",
    contact: "Contact",
    callNow: "Call Now",
  },
  hero: {
    eyebrow: "Professional cleaning in NJ & NY",
    titleA: "Clean spaces,",
    titleB: "better lives.",
    sub: "Bilingual, bonded & insured cleaning with eco-friendly products across New Jersey and New York. Book in minutes and let the Rosas crew make your home shine.",
    primary: "Book a Cleaning",
    secondary: "See Pricing",
    trustA: "Bonded & Insured",
    trustB: "Bilingual crews",
    trustC: "Eco-friendly products",
    trustD: "100% Satisfaction",
  },
  stats: {
    homes: "Homes cleaned",
    areas: "States served",
    rating: "Average rating",
    years: "Years of experience",
  },
  services: {
    eyebrow: "Services",
    title: "Cleaning built for every space",
    sub: "Competitive NJ & NY pricing. No surprises, no fine print.",
    cta: "Get Quote",
    items: [
      {
        key: "regular",
        title: "Houses",
        desc: "Recurring weekly, biweekly or monthly cleanings to keep your home flawless.",
        price: "From $120",
        features: ["Kitchen & baths", "Dust & floors", "Products included"],
      },
      {
        key: "deep",
        title: "Deep Cleaning",
        desc: "Top-to-bottom detail. Ideal every 3-6 months or before special events.",
        price: "From $220",
        features: ["Inside ovens", "Bathroom detail", "Baseboards & windows"],
      },
      {
        key: "apartment",
        title: "Apartments",
        desc: "Fast, affordable service for NJ and NY apartments.",
        price: "From $110",
        features: ["Studios & 1-BR", "Hotel-grade finish", "Quick availability"],
      },
      {
        key: "office",
        title: "Offices",
        desc: "Commercial spaces that reflect professionalism. After-hours service.",
        price: "From $150",
        features: ["Common areas", "Sanitization", "Flexible schedule"],
      },
      {
        key: "move_in_out",
        title: "Move-in / Move-out",
        desc: "Spotless handoff. Perfect for moves and getting your deposit back.",
        price: "From $280",
        features: ["Empty unit", "Cabinet interiors", "Photo report"],
      },
      {
        key: "post_construction",
        title: "Post-Construction",
        desc: "We remove construction dust and debris, leaving your project move-in ready.",
        price: "From $350",
        features: ["Fine dust", "Debris & stickers", "Surface polish"],
      },
    ],
  },
  pricing: {
    eyebrow: "Transparent pricing",
    title: "Plans built for NJ & NY",
    sub: "Competitive rates. Automatic discounts on recurring visits.",
    monthly: "per visit",
    cta: "Choose plan",
    plans: [
      {
        name: "Basic",
        price: "$120",
        for: "Weekly upkeep",
        features: ["Up to 2 bedrooms", "Kitchen + 1 bath", "Dust, vacuum, mop", "Products included"],
        highlight: false,
      },
      {
        name: "Deep",
        price: "$220",
        for: "Every 1-3 months",
        features: [
          "Up to 3 bedrooms",
          "Bathroom detailing",
          "Kitchen + appliances",
          "Baseboards, frames & windows",
          "Eco products included",
        ],
        highlight: true,
      },
      {
        name: "Premium",
        price: "$350",
        for: "Move-in / Out / Post-construction",
        features: [
          "Up to 4 bedrooms",
          "Cabinet & oven interiors",
          "Interior window wash",
          "Photo report",
          "48-hour guarantee",
        ],
        highlight: false,
      },
    ],
    note: "Pricing may vary with size (sqft), soil level and city. We confirm before we start.",
  },
  how: {
    eyebrow: "How it works",
    title: "Booking is this simple",
    steps: [
      { n: "01", t: "Request a quote", d: "Fill the form or call us. We respond in under 2 hours." },
      { n: "02", t: "We confirm details", d: "Day, time, address and service locked in. Flat price." },
      { n: "03", t: "Your Rosas crew arrives", d: "On time, uniformed, fully equipped." },
      { n: "04", t: "Enjoy your space", d: "Flawless home with satisfaction guarantee." },
    ],
  },
  why: {
    eyebrow: "Why Rosas",
    title: "The cleaning standard your home deserves",
    items: [
      { t: "Bonded & Insured", d: "Full peace of mind: registered and covered in NJ and NY." },
      { t: "Bilingual Team", d: "Clear communication in Spanish and English." },
      { t: "Eco-friendly Products", d: "Safe for family, pets and the planet." },
      { t: "48h Guarantee", d: "Anything off? We come back at no extra cost." },
      { t: "Vetted Staff", d: "Background checked and continuously trained." },
      { t: "Flexible Booking", d: "Reschedule free with 24h notice. No contracts." },
    ],
  },
  areas: {
    eyebrow: "Coverage",
    title: "We serve New Jersey and New York",
    sub: "Full metropolitan coverage across NJ and NY. Not sure if we serve your area? Call us.",
  },
  testimonials: {
    eyebrow: "What clients say",
    title: "NJ & NY families trust Rosas",
    items: [
      {
        n: "Maria G.",
        c: "Jersey City, NJ",
        q: "My apartment looks brand new. They're punctual and the crew is so kind. Booked biweekly!",
      },
      {
        n: "James R.",
        c: "Manhattan, NY",
        q: "They did a deep clean before my party and everyone asked who cleans for us. Highly recommended.",
      },
      {
        n: "Ana P.",
        c: "Hoboken, NJ",
        q: "Spotless move-out, got 100% of my deposit back. Bilingual and super professional.",
      },
      {
        n: "Daniel V.",
        c: "Brooklyn, NY",
        q: "Fair pricing and incredible results. Non-toxic products — perfect with a baby at home.",
      },
    ],
  },
  booking: {
    eyebrow: "Book now",
    title: "Tell us about your space",
    sub: "We'll send a quote within 2 business hours.",
    name: "Full name",
    phone: "Phone",
    email: "Email (optional)",
    service: "Service type",
    date: "Preferred date",
    address: "Address",
    city: "City",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    sqft: "Size (sqft, optional)",
    frequency: "Frequency",
    freqOptions: {
      one_time: "One time",
      weekly: "Weekly (-15%)",
      biweekly: "Biweekly (-10%)",
      monthly: "Monthly (-5%)",
    },
    notes: "Additional notes",
    submit: "Send request",
    submitting: "Sending...",
    success: "Request sent! We'll contact you soon.",
    error: "Could not send. Call us at 347-785-5458.",
    estimated: "Estimated",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Your questions, answered",
    items: [
      {
        q: "How much does it cost to clean my NJ or NY home?",
        a: "Regular cleaning starts at $120 and deep cleaning at $220. Final price depends on size, bedroom count and soil level. We confirm pricing before we start.",
      },
      {
        q: "Do you bring your own supplies?",
        a: "Yes. We include eco-friendly products and all equipment. If you'd rather we use yours, we're happy to.",
      },
      {
        q: "Do I need to be home?",
        a: "Not at all. Many clients give us entry instructions (lockbox, doorman, code). We're insured and bonded for your peace of mind.",
      },
      {
        q: "What if I'm not satisfied?",
        a: "You have 48 hours to let us know and we'll come back at no charge. That's our Rosas guarantee.",
      },
      {
        q: "Do you work weekends?",
        a: "Yes — Saturdays and select Sundays by appointment. Please book at least 48 hours in advance.",
      },
      { q: "Do you speak Spanish?", a: "Yes — 100% bilingual Spanish/English team." },
    ],
  },
  footer: {
    tagline: "Professional cleaning with heart. We serve the entire NJ & NY metro area.",
    nav: "Navigate",
    services: "Services",
    contact: "Contact",
    hours: "Mon–Sat: 8AM – 7PM",
    rights: "All rights reserved.",
  },
};

export const dict = { es, en };
